import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ContentChildren,
  QueryList,
  AfterContentInit,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { FeatherModule } from 'angular-feather';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

import { ValueComponent } from '~/v2/core/valuecomponent';

@Component({
  selector: 'app-choice',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class ChoiceComponent {
  @Input() display: string | null = null;
  @Input() key: any | null = null;
  @Input() recommendedLabel: string | null = null;
  @Input() disabled: boolean | null = null;
  @Input() choiceTooltip: string | null = null;
}

@Component({
  selector: 'app-choices',
  templateUrl: './choice.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FeatherModule, NgbTooltip, NgClass, TranslatePipe],
})
export class ChoicesComponent extends ValueComponent<any> implements OnChanges, AfterContentInit, AfterViewInit {
  @ContentChildren(ChoiceComponent) choices: QueryList<ChoiceComponent> | null = null;

  @Input() title: string | null = null;
  @Input() required: boolean | null = null;
  @Input() isReadOnly: boolean | null = null;
  @Input() hideReadOnlyLabel: boolean | null = null;
  @Input() disabled = false;
  @Input() tooltip: string | null = null;
  @Input() columnSpanClass = 'col-sm-12';
  @Input() defaultValue: number | null = null;

  valueTemplate: string | null = null;
  choiceComponentIdentifier: string | null = null;

  private changeDetectorRef: ChangeDetectorRef;
  private static globalIdentifier = 1;

  constructor(changeDetectorRef: ChangeDetectorRef) {
    super();

    this.changeDetectorRef = changeDetectorRef;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] == undefined || changes['value'] == null) {
      return;
    }

    this.value = changes['value'].currentValue;

    this.setValueTemplate();
  }

  private setValueTemplate(): void {
    if (!this.choices) {
      return;
    }

    const selectedChoice = this.choices.find((x) => x.key == this.value);
    if (selectedChoice) {
      this.valueTemplate = selectedChoice.display;
    }
  }

  isEmpty(): boolean {
    return this.value == undefined || this.value == null || this.value == '';
  }

  ngAfterContentInit(): void {
    if (this.value) {
      this.setValueTemplate();
    }

    this.choiceComponentIdentifier = `choice_${ChoicesComponent.globalIdentifier}`;
    ChoicesComponent.globalIdentifier++;
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
    if (this.value) {
      this.setValueTemplate();
    }
  }

  setColumnSpan(columnSpan: string): void {
    this.columnSpanClass = `col-sm-${columnSpan}`;
  }

  onChoiceChange(choice: ChoiceComponent): void {
    this.value = choice.key!;
    this.valueTemplate = choice.display;
    super.onChange(choice.key!);
  }
}
